﻿(function () {

    'use strict';
    var serviceId = 'repository.repairtime';
    angular
        .module('app.services')
        .factory(serviceId, repairtime);

    repairtime.$inject = ['common', 'repository.abstract', '$http'];

    function repairtime(common, abstractRepository, $http) {
        var config = common.config;

        function Ctor(mgr) {
            this.manager = mgr;
            this.getFilters = getFilters;
            this.getCarrierList = getCarrierList;
            this.getDateTypes = getDateTypes;
            this.getRepairTimeList = getRepairTimeList;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function getFilters() {
            var authData = common.localStorageService.get('authorizationData');
            var codeRole = authData ? authData.userRole : "";
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetContainerReceptionFilters?codeRole=' + codeRole);
        }

        function getCarrierList() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetCarrierList');
        }

        function getDateTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'reportList/GetDateTypes');
        }

        function getRepairTimeList(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'reportList/GetRepairTimeList', model);
        }
    }

})();
